module.exports = __webpack_public_path__ + "static/media/salisbury-25.3d41b89e.jpg";